function NoData() {
  return <div className="no-data">Data not available.</div>
}
export default NoData
